<template>
  <div class="edition-table">
    <table>
      <thead>
        <th>
          Tipo
          <InfoTooltip
            :tooltipMinWidth="200"
            text="Relação de hóspedes, de acordo com a configuração de PAX."
            class="tooltip-space"
          />
        </th>

        <th>
          Tipo de valor
          <InfoTooltip
            :tooltipMinWidth="210"
            text="Se os valores para acréscimo ou desconto, em relação à tarifa base, representam um valor monetário absoluto ou um em percentual."
            class="tooltip-space"
          />
        </th>

        <th>
          Valor 1º adicional
          <InfoTooltip
            :tooltipMinWidth="210"
            text="Valor a ser acrescido para o primeiro PAX adicional em relação à quantidade base do quarto."
            class="tooltip-space"
          />
        </th>

        <th>
          Valor 2º adicional
          <InfoTooltip
            :tooltipMinWidth="210"
            text="Valor a ser acrescido para o segundo PAX adicional em relação à quantidade base do quarto."
            class="tooltip-space"
          />
        </th>

        <th>
          Valor 3º adicional
          <InfoTooltip
            :tooltipMinWidth="210"
            text="Valor a ser acrescido para o terceiro PAX adicional em relação à quantidade base do quarto."
            class="tooltip-space"
          />
        </th>

        <th>
          Valor 4º adicional
          <InfoTooltip
            :tooltipMinWidth="210"
            text="Valor a ser acrescido para o quarto PAX adicional em relação à quantidade base do quarto."
            class="tooltip-space"
          />
        </th>

        <th>
          Valor 5º adicional
          <InfoTooltip
            :tooltipMinWidth="210"
            text="Valor a ser acrescido para o quinto PAX adicional em relação à quantidade base do quarto."
            class="tooltip-space"
          />
        </th>
      </thead>

      <tbody>
        <!-- LINHA -->
        <tr v-for="(pax, i) in paxes" :key="`pax-${pax.codigoPax || i}`">
          <!-- NOME DO PAX -->
          <td class="td--padd__text">{{ pax.nomePax }}</td>

          <!-- TIPO DE VALOR -->
          <td class="td--padd">
            <FormSelect
              v-model="pax.tipoValor"
              :options="paxTypeOptions"
              :disabled="pax.maximoOcupantesAdicionais < 1"
              label=""
              class="td--padd__select"
            />
          </td>

          <!-- VALOR -->
          <td
            v-for="(ocupante, j) in pax.tableOcupantes"
            :key="`pax-${j}`"
            class="td--padd"
          >
            <FormInput
              v-if="pax.tipoValor.value === 1"
              v-model="ocupante.valor"
              :id="`pax-${j}`"
              :disabled="pax.maximoOcupantesAdicionais < j + 1"
              :placeholder="
                pax.maximoOcupantesAdicionais < j + 1 ? null : '00,00'
              "
              :sufix="pax.maximoOcupantesAdicionais < j + 1 ? null : '%'"
              label=""
              class="td--padd__input"
            />
            <PmwFormCurrencyInput
              v-else-if="pax.tipoValor.value === 2"
              v-model="ocupante.valor"
              :options="{ precision: 2 }"
              :id="`pax-${j}`"
              :disabled="pax.maximoOcupantesAdicionais < j + 1"
              :placeholder="
                pax.maximoOcupantesAdicionais < j + 1 ? null : '00,00'
              "
              :suffix="pax.maximoOcupantesAdicionais < j + 1 ? null : 'R$'"
              size="large"
              label=""
              class="td--padd__input"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
/** ======================================================= */
/** Componente da tabela de tipo de Pax */
/** ======================================================= */
import FormInput from '@solucoes/components-lib-tmp/src/components/elements/FormInput'
import PmwFormCurrencyInput from '@solucoes/components-lib-tmp/src/components/patterns/PmwFormCurrencyInput'
import FormSelect from '@solucoes/components-lib-tmp/src/components/elements/FormSelect'
import InfoTooltip from '@solucoes/components-lib-tmp/src/components/patterns/InfoTooltip'

export default {
  name: 'PaxTable',
  components: {
    FormInput,
    PmwFormCurrencyInput,
    FormSelect,
    InfoTooltip
  },
  props: {
    /** Controla o envio dos dados para a página */
    sendData: {
      type: Boolean,
      default: false
    },
    /** Configuração dos Paxes */
    paxes: {
      type: Array,
      default: () => []
    },
    /** Opções de tipo de valor */
    paxTypeOptions: {
      type: Array,
      default: () => []
    }
  },

  watch: {
    /** Realiza o envio de dados */
    sendData() {
      this.$emit('input', this.paxes)
    }
  }
}
</script>

<style lang="scss" scoped>
.tooltip-space {
  margin-left: 5px;
  text-align-last: left;
}

.edition-table {
  max-width: 1236px;

  table {
    th {
      padding: 15px 7.5px;
    }

    th,
    td {
      vertical-align: middle;
      border: 1px solid $gray-border;
      font-size: font-size('size-small');
      white-space: nowrap;

      & + & {
        border-left: none;
      }

      &.empty {
        background-color: $gray-lightest;
      }
    }

    th {
      font-weight: font-weight('weight-medium');
      text-align-last: center;
    }

    .td {
      padding: 0;

      &--padd {
        text-align: -webkit-center;
        padding: 15px 0px;
        ::v-deep .input-checkbox {
          margin: 120px auto;
          display: table;
        }
        &__text {
          font-weight: font-weight('weight-medium');
          color: pmw-colors('grey-80');
          text-align: -webkit-center;
          padding: 10px;
        }
        &__select {
          width: 125px;
          margin-bottom: 15px;
        }
        &__input {
          width: 100px;
          margin-bottom: 15px;
        }
      }
    }
  }
}
table th:nth-child(2) {
  padding: 15px 27.5px;
}

::v-deep .select-options-list {
  width: 120px;
}
</style>
